export { ContactGeneral } from "./contact-general";
